import { cirrusApi } from 'App/rtk';
import {
  TrialExpiredAbTestEndpoints,
  TRIAL_EXPIRED_AB_TEST_URL,
} from './config';
import { trialExpiredAbTestApiTags } from './tags';

export const trialExpiredAbTestApi = cirrusApi
  .enhanceEndpoints({
    addTagTypes: [trialExpiredAbTestApiTags.trialExpiredSetTestVariant],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      [TrialExpiredAbTestEndpoints.setTrialExpiredVariant]: builder.mutation<
        void,
        void
      >({
        query: () => ({
          method: 'POST',
          url: TRIAL_EXPIRED_AB_TEST_URL,
        }),
      }),
    }),
  });

export const { useSetTrialExpiredVariantMutation } = trialExpiredAbTestApi;
